const breakpoints = ['320px', '375px', '721px', '834px', '1152px', '1440px', '2560px'];
const breakpointsMax = ['374px', '720px', '833px', '1151px', '1439px', '2559px', '99999px'];
const labels = ['mobile_s', 'mobile_l', 'tablet_s', 'tablet_l', 'desktop_s', 'desktop_l', 'desktop_xl'];

export { breakpoints, breakpointsMax, labels };
